module.exports = __webpack_public_path__ + "img/wechat_code.68d2e8a4.png";